export function scrollIntoViewIfNeeded(el: HTMLElement): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const anyEl = el as any;
  if (anyEl.scrollIntoViewIfNeeded) anyEl.scrollIntoViewIfNeeded();
  else anyEl.scrollIntoView?.();
}
